const StateTextField = ({ state, color, width, fontsize, small, height, paddingTop }) => {
    return !small ? (
        <div style={{ fontFamily: 'Gothic', paddingTop: paddingTop ? paddingTop : null, width: width ? width : '6em', height: height ? height : null, borderRadius: '0.4em', paddingRight: '5px', paddingLeft: '5px', backgroundColor: color, color: 'white', fontSize: fontsize, display:'inline-block' }}>{state}</div>
    ) : (
        <div style={{ background: color, borderRadius: '60%', width: '1em', height: '1em', display:'inline-block' }}></div>
    );
}
export default StateTextField;